import colors from '@magoosh/lib/styles/colors.module.scss';

export default (examName: string, sections: string) => {
  if (examName === 'GMAT') {
    const quant = {
      name: 'Quantitative Reasoning',
      data: [
        { color: colors.gray85, label: 'Correct', value: 100 },
        { color: colors.grayLightest, label: 'Inorrect', value: 0 }
      ]
    };
    const verbal = {
      name: 'Verbal Reasoning',
      data: [
        { color: colors.gray85, label: 'Correct', value: 100 },
        { color: colors.grayLightest, label: 'Inorrect', value: 0 }
      ]
    };
    const data = {
      name: 'Data',
      data: [
        { color: colors.gray85, label: 'Correct', value: 100 },
        { color: colors.grayLightest, label: 'Inorrect', value: 0 }
      ]
    };

    if (!sections || sections === 'all') {
      return [quant, verbal, data];
    }

    let result = [];

    if (sections.indexOf('quantitative_reasoning') !== -1){
      result.push(quant);
    }
    if (sections.indexOf('verbal_reasoning') !== -1) {
      result.push(verbal);
    }
    if (sections.indexOf('data_insights') !== -1) {
      result.push(data);
    }

    return result;
  } else if (examName === 'GRE') {
    const math = {
      name: 'Math',
      data: [
        { color: colors.gray85, label: 'Correct', value: 100 },
        { color: colors.grayLightest, label: 'Inorrect', value: 0 }
      ]
    };
    const verbal = {
      name: 'Verbal',
      data: [
        { color: colors.gray85, label: 'Correct', value: 100 },
        { color: colors.grayLightest, label: 'Inorrect', value: 0 }
      ]
    };

    if (!sections || sections === 'all') {
      return [math, verbal];
    }

    let result = [];

    if (sections.indexOf('math') !== -1) {
      result.push(math);
    }
    if (sections.indexOf('verbal') !== -1) {
      result.push(verbal);
    }

    return result;
  } else if (examName === 'SAT') {
    const reading_writing = {
      name: 'Reading & Writing',
      data: [
        { color: colors.gray85, label: 'Correct', value: 100 },
        { color: colors.grayLightest, label: 'Inorrect', value: 0 }
      ]
    };
    const math = {
      name: 'Math',
      data: [
        { color: colors.gray85, label: 'Correct', value: 100 },
        { color: colors.grayLightest, label: 'Inorrect', value: 0 }
      ]
    };
    if (!sections || sections === 'all') {
      return [reading_writing, math];
    }

    let result = [];

    if (sections.indexOf('reading_and_writing') !== -1) {
      result.push(reading_writing);
    }
    if (sections.indexOf('math') !== -1){
      result.push(math);
    }

    return result;
  } else if (examName === 'TOEFL') {
    const reading = {
      name: 'Reading',
      data: [
        { color: colors.gray85, label: 'Correct', value: 100 },
        { color: colors.grayLightest, label: 'Inorrect', value: 0 }
      ]
    };
    const listening = {
      name: 'Listening',
      data: [
        { color: colors.gray85, label: 'Correct', value: 100 },
        { color: colors.grayLightest, label: 'Inorrect', value: 0 }
      ]
    };
    const speaking = {
      name: 'Speaking',
      data: [
        { color: colors.gray85, label: 'Correct', value: 100 },
        { color: colors.grayLightest, label: 'Inorrect', value: 0 }
      ]
    };
    const writing = {
      name: 'Writing',
      data: [
        { color: colors.gray85, label: 'Correct', value: 100 },
        { color: colors.grayLightest, label: 'Inorrect', value: 0 }
      ]
    };

    if (!sections || sections === 'all') {
      return [reading, listening, speaking, writing];
    }

    let result = [];

    if (sections.indexOf('reading') !== -1) {
      result.push(reading);
    }
    if (sections.indexOf('listening') !== -1){
      result.push(listening);
    }
    if (sections.indexOf('speaking') !== -1){
      result.push(speaking);
    }
    if (sections.indexOf('writing') !== -1){
      result.push(writing);
    }

    return result;
  } else {
    return [];
  }
};
